import Vue from "vue";
import { newLogger } from "@/utils/util";
import axios from "axios";
import network from "../../../utils/network";

let logger = newLogger("AcceptanceRequirementsStore");

const urls = {
  registration: "/api/administration/merchant-registration-acceptance",
  accept: "/merchant/statement/accept", // POST
  statementsForApplication: (applicationId) =>
    `/merchant/statements/${applicationId}`,
};

/**
 * Administration Registration Page Configuration store
 */

const initState = () => {
  return {
    registrationStatements: [],
    statementsForApplication: {},
  };
};

const actions = {
  fetchRegistrationStatements: async ({ commit }) => {
    try {
      let { data } = await axios.get(urls.registration);
      commit("saveReg", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  acceptStatement: async (_, request) => {
    try {
      let axios = await network.connection();
      await axios.post(urls.accept, request);
      return true;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  statementsForApplication: async ({ commit }, applicationId) => {
    try {
      let axios = await network.connection();
      let { data } = await axios.get(
        urls.statementsForApplication(applicationId)
      );
      commit("saveStatementsForApplication", { data, applicationId });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveReg: (state, configurations) => {
    Vue.set(state, "registrationStatements", configurations);
  },
  saveStatementsForApplication: (state, { data, applicationId }) => {
    Vue.set(state.statementsForApplication, applicationId, data);
  },
};

const getters = {
  registrationStatements: (state) => {
    return state.registrationStatements;
  },
  statementsForApplication: (state) => (applicationId) => {
    return state.statementsForApplication[applicationId];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations,
  actions,
  getters,
};
